import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { InputControlBase } from './../forms/input-control.base';

/** @deprecated Use `astral-checkbox` in new or Astralized templates. */
@Component({
    selector: 'app-check-box',
    templateUrl: './check-box.component.html',
    styleUrls: ['./check-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckBoxComponent extends InputControlBase {
  constructor() {
    super();
  }

  onchange(e: MatCheckboxChange) {
    this.valueChange.emit({ formSnapshot: this.control.parent?.value, newValue: e.checked, previousValue: !e.checked });
  }
}
